import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence benign "ResizeObserver loop" errors (fired by React Flow / MiniMap on resize)
// so CRA's dev error overlay does not flash on first paint.
const _roErr = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message && e.message.includes(_roErr)) { e.stopImmediatePropagation(); e.preventDefault(); }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
